<script setup lang="ts">
import { useBrands } from '~/data/brands';
import { EntityCarouselSmall } from '@laam/ui/cms';
import type { EntityData } from '@laam/cms-shared';
import BrandLogoCard from './BrandLogoCard.vue';
import CarouselLoader from './CarouselLoader.vue';
import { useStatsigExperiment } from '~/utils/use-statsig-experiment';
const { brandListingExperiment } = useStatsigExperiment();
interface CarouselColumn {
	hideColumns: boolean;
}
const props = withDefaults(defineProps<CarouselColumn>(), {
	hideColumns: false,
});
const showSection1 = computed(() => {
	return (
		!props.hideColumns &&
		(brandListingExperiment?.value?.variant === '1' ||
			brandListingExperiment?.value?.variant === '2')
	);
});
const showSection2 = computed(() => {
	return (
		!props.hideColumns &&
		(brandListingExperiment?.value?.variant === '1' ||
			brandListingExperiment?.value?.variant === '3')
	);
});
const hydrated = ref(false);

onMounted(() => {
	hydrated.value = true;
});
const { data: trendingBrands, isLoading: isTrendingBrandsLoading } = useBrands({
	enabled: computed(() => hydrated.value && showSection1.value),
	filters: computed(() => ({
		limit: 12,
		sort_by: 'RECOMMENDED',
	})),
});

const { data: newBrands, isLoading: isNewBrandsLoading } = useBrands({
	enabled: computed(() => hydrated.value && showSection2.value),
	filters: computed(() => ({
		limit: 12,
		sort_by: 'BEST_SELLING',
		timePeriod: '30d',
		created_at: '30d',
	})),
});

const brandsMetadata = {
	alignment: 'left',
	entity: 'brands',
	method: 'static',
	input: {
		ids: [],
	},
};
</script>
<template>
	<template v-if="showSection1">
		<CarouselLoader v-if="isTrendingBrandsLoading" />
		<EntityCarouselSmall
			v-else-if="trendingBrands"
			class="py-3xl lg:py-none gap-xl bg-white"
			:metadata="
				{
					...brandsMetadata,
					title: 'Trending Brands',
				} as EntityData
			"
			:section-index="1"
			:data="trendingBrands"
			:loading="isTrendingBrandsLoading"
			:mobile-items-count="4"
			:show-dots="false"
		>
			<template #default="{ data: entityData, horizontalIndex }">
				<BrandLogoCard
					:entity-data="entityData"
					:horizontal-index="horizontalIndex"
					carousel="trending"
				/>
			</template>
		</EntityCarouselSmall>
	</template>
	<template v-if="showSection2">
		<CarouselLoader v-if="isNewBrandsLoading" />
		<EntityCarouselSmall
			v-else-if="newBrands"
			class="py-3xl lg:py-none gap-xl bg-white"
			:metadata="
				{
					...brandsMetadata,
					title: 'New Brands',
				} as EntityData
			"
			:section-index="1"
			:data="newBrands"
			:loading="isNewBrandsLoading"
			:mobile-items-count="4"
			:show-dots="false"
		>
			<template #default="{ data: entityData, horizontalIndex }">
				<BrandLogoCard
					:entity-data="entityData"
					:horizontal-index="horizontalIndex"
					carousel="new"
				/>
			</template>
		</EntityCarouselSmall>
	</template>
</template>
